import { useMemo } from "react";
import { useRescheduleInfiniteQuery } from "../../../../entities/reschedule";
import { useDebounce } from "../../../../shared/hooks/useDebounce";
import {
  mapFiltersFormToApi,
  RescheduleFiltersForm,
} from "./rescheduleFilters.types";
import {
  toRescheduleFiltersForm,
  useRescheduleFiltersParams,
} from "./useRescheduleFiltersParams";

const PAGE_LIMIT = 20;

export function useRescheduleFilters() {
  const [params, setParams] = useRescheduleFiltersParams();

  const filters = useMemo<RescheduleFiltersForm>(
    () => toRescheduleFiltersForm(params),
    [params],
  );

  const debouncedFilters = useDebounce(filters, 400);

  const apiFilters = useMemo(
    () => mapFiltersFormToApi(debouncedFilters, PAGE_LIMIT),
    [debouncedFilters],
  );

  const query = useRescheduleInfiniteQuery(apiFilters);

  return {
    filters,
    setFilters: setParams,
    ...query,
  };
}
